// composables/useVisibilityToggles.ts
import { ref, watch } from 'vue'

// Module-level refs so the master switches and every chapter's individual
// toggle share the same state across all component instances.
const showInfoGlobal = ref(false)
const showRechtstextGlobal = ref(true)

export function useVisibilityMasterToggles() {
  return { showInfoGlobal, showRechtstextGlobal }
}

// Each chapter's individual info/legal-text toggle starts at the current
// master value and snaps back to it whenever the master switch changes,
// while still being freely toggleable on its own in between.
export function useInfoToggle() {
  const show = ref(showInfoGlobal.value)
  watch(showInfoGlobal, (value) => {
    show.value = value
  })
  return show
}

export function useRechtstextToggle() {
  const show = ref(showRechtstextGlobal.value)
  watch(showRechtstextGlobal, (value) => {
    show.value = value
  })
  return show
}
